<template>
  <div class="contents">
    <div class="content_map">
      <div class="tablist_item">
        <div
          class="items"
          :class="[{ active: activeName == item.name }]"
          v-for="item in itemList"
          :key="item.id"
          @click="tabItemClick(item)"
        >
        <img v-if="item.id==8" src="../../assets/img/ms/hot.png" alt=""/>
          {{ item.name }}
        </div>
      </div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import NJNav from "../Index/nav.vue";
export default {
  components: {
    NJNav
  },
  data() {
    return {
      activeName: "农机分布热力图",
      itemList: [
        {
          id: 1,
          name: "农机分布热力图"
        },
        {
          id: 2,
          name: "各省补贴机具统计"
        },
        {
          id: 3,
          name: "当日作业农机热力图"
        },
        {
          id: 4,
          name: "农机作业进度"
        },
        {
          id: 5,
          name: "农机作业趋势"
        },
        {
          id: 6,
          name: "农机预警统计"
        },
        {
          id: 7,
          name: "补贴用户作业排行",
        },
        {
          id: 8,
          name: "麦收进度管理"
        }
      ],
      machineShow: true,
      mapShow: false,
      areasuperShow: false,
      operationShow: false
    };
  },
  mounted() {
  	this.secondTitle= this.$store.state.areaName === '全国'?'各省补贴机具统计':'各地区农机统计'
  	this.itemList[1].name = this.secondTitle
    if (window.location.pathname === "/view/ToolDistributionHeat") {
      this.activeName = "农机分布热力图";
      this.$router.push("/ToolDistributionHeat");
    } else if (window.location.pathname === "/view/ToolStatistics") {
      this.activeName = this.secondTitle;
      this.$router.push("/ToolStatistics");
    } else if (window.location.pathname === "/view/WorkHeatMap") {
      this.activeName = "当日作业农机热力图";
      this.$router.push("/WorkHeatMap");
    } else if (window.location.pathname === "/view/ToolWorkProgress") {
      this.activeName = "农机作业进度";
      this.$router.push("/ToolWorkProgress");
    } else if (window.location.pathname === "/view/ToolWorkTrend") {
      this.activeName = "农机作业趋势";
      this.$router.push("/ToolWorkTrend");
    } else if (window.location.pathname === "/view/ToolWorkRank") {
      this.activeName = "补贴用户作业排行";
      this.$router.push("/ToolWorkRank");
    } else if (window.location.pathname === "/view/WarningEquipment") {
      this.activeName = "农机预警统计";
      this.$router.push("/WarningEquipment");
    }
  },
  methods: {
    tabItemClick(item) {
      this.activeName = item.name;
      if (item.id === 1) {
        this.$router.push("/ToolDistributionHeat");
      } else if (item.id === 2) {
        this.$router.push("/ToolStatistics");
      } else if (item.id === 3) {
        this.$router.push("/WorkHeatMap");
      } else if (item.id === 4) {
        this.$router.push("/ToolWorkProgress");
      } else if (item.id === 5) {
        this.$router.push("/ToolWorkTrend");
      } else if (item.id === 7) {
        this.$router.push("/ToolWorkRank");
      } else {
        this.$router.push("/WarningEquipment");
      }
    }
  }
};
</script>
<style scoped>
.contents {
  width: 100%;
  height: 100%;
}

.content_map {
  width: 98%;
  margin: 0 auto;
  background-image: url("/static/img/nav.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.tablist_item {
  display: flex;
}
.items {
  height: 40px;
  font-size: 13px;
  color: #C6CBE4;
  text-align: center;
  line-height: 44px;
  border-radius: 2px;
  cursor: pointer;    margin: 0 20px;
}
.items.active {
  height: 40px;
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 44px;
  border-radius: 2px;
  background-image: url("/static/img/active-nav.png");
  background-size: 100% 20%;
  background-repeat: no-repeat;
  background-position: bottom;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/TableList/MachMonitor.vue